import React, { useLayoutEffect } from "react";
import { graphql } from "gatsby";
import { useDataLayer } from "../hooks/dataLayer";
import ReviewCard from "../components/modules/ReviewCard";
import SEO from "../components/seo";
import Impact from "../components/impact/universalTracking";

export default function WriteAReview({ data }) {
  const page = data.datoCmsProductReview;
  const { pageTitle, subTitle, description, productReviews } = page;

  useLayoutEffect(() => {
    window.dispatchEvent(new CustomEvent("getStats"));
  }, []);

  useDataLayer({ pageType: "other" });

  return (
    <>
      <Impact />
      <SEO title={pageTitle} description={description} />
      <section className="CallToAction hds-container bg-white hds-text-color ">
        <div className="hds-section  flex flex-wrap md:justify-center text-left md:text-center ">
          <div className="w-full max-w-xl m-auto">
            <h4 className="hds-title__large hds-title-color mb-sm font-black uppercase font-heading">
              {pageTitle}
            </h4>
            <p className="hds-copy mb-sm text-left md:text-center">
              {subTitle}
            </p>
            <div className=""></div>
          </div>
        </div>
      </section>
      <section className="Product hds-container bg-white hds-text-color">
        <div className="hds-section-sm">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-sm">
            {productReviews.map((item) => {
              return <ReviewCard item={item} />;
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export const writeAReviewQuery = graphql`
  query {
    datoCmsProductReview {
      subTitle
      pageTitle
      description
      id
      productReviews {
        categoryId
        productId
        categoryTitle
        productCategoryImage {
          alt
          gatsbyImageData
        }
      }
    }
  }
`;
